var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPeople(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.9957 13.1267C32.8857 13.1084 32.7574 13.1084 32.6474 13.1267C30.1174 13.035 28.1007 10.9634 28.1007 8.39669C28.1007 5.77502 30.209 3.66669 32.8307 3.66669C35.4524 3.66669 37.5607 5.79336 37.5607 8.39669C37.5424 10.9634 35.5257 13.035 32.9957 13.1267Z",
    stroke: "#00A6A6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1071 26.4733C33.6188 26.895 36.3871 26.455 38.3305 25.1533C40.9155 23.43 40.9155 20.6067 38.3305 18.8833C36.3688 17.5817 33.5638 17.1417 31.0521 17.5817",
    stroke: "#00A6A6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9404 13.1267C11.0504 13.1084 11.1787 13.1084 11.2887 13.1267C13.8187 13.035 15.8354 10.9634 15.8354 8.39669C15.8354 5.77502 13.727 3.66669 11.1054 3.66669C8.4837 3.66669 6.37537 5.79336 6.37537 8.39669C6.3937 10.9634 8.41037 13.035 10.9404 13.1267Z",
    stroke: "#00A6A6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8287 26.4733C10.317 26.895 7.54871 26.455 5.60538 25.1533C3.02038 23.43 3.02038 20.6067 5.60538 18.8833C7.56704 17.5817 10.372 17.1417 12.8837 17.5817",
    stroke: "#00A6A6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22 26.8217C21.89 26.8034 21.7616 26.8034 21.6516 26.8217C19.1216 26.73 17.105 24.6584 17.105 22.0917C17.105 19.47 19.2133 17.3617 21.835 17.3617C24.4566 17.3617 26.565 19.4884 26.565 22.0917C26.5466 24.6584 24.53 26.7484 22 26.8217Z",
    stroke: "#292D32",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6649 32.5967C14.0799 34.3201 14.0799 37.1434 16.6649 38.8667C19.5983 40.8284 24.4016 40.8284 27.3349 38.8667C29.9199 37.1434 29.9199 34.3201 27.3349 32.5967C24.4199 30.6534 19.5983 30.6534 16.6649 32.5967Z",
    stroke: "#292D32",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/people.030c745c78cc5159c21322daac6e78ad.svg";
export { ForwardRef as ReactComponent };